var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 14L3.88889 11.1111M2.44444 6.77778C2.44444 8.31014 3.05317 9.77974 4.13672 10.8633C5.22026 11.9468 6.68986 12.5556 8.22222 12.5556C9.75458 12.5556 11.2242 11.9468 12.3077 10.8633C13.3913 9.77974 14 8.31014 14 6.77778C14 5.24542 13.3913 3.77582 12.3077 2.69227C11.2242 1.60873 9.75458 1 8.22222 1C6.68986 1 5.22026 1.60873 4.13672 2.69227C3.05317 3.77582 2.44444 5.24542 2.44444 6.77778Z",
    stroke: "#E6E6E6",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.70488d831995b0fcb140d03c99e8e8b8.svg";
export { ForwardRef as ReactComponent };